import Route from 'route-parser';

import {
  setSelectedBrandAction,
  setSelectedLocationAction,
} from 'containers/Auth_old/actions';
import { WHOAMI_SUCCESS } from 'containers/Auth_old/constants';
import { initialState } from 'containers/Auth_old/reducer';
import { MIGRATED_PARENT_ACCOUNT_SLUGS } from 'utils/constants';
import { history } from 'utils/history';

/**
 * This middleware captures WHOAMI_SUCCESS action to update the
 * selected brand based on the url. This will ensure that the url and
 * the store stays in sync
 */

const urlToStoreMiddleware = store => next => action => {
  if (action.type === WHOAMI_SUCCESS) {
    // Let the original reducer do its thing
    next(action);

    const path = store.getState().router.location.pathname;
    const { search = '', hash = '' } = store.getState().router.location;
    const route = Route(
      `/:accountSlug(/brands/:brandSlug(/locations(/:locationId))(/*rest1))(/*rest2)`,
    );
    const parsed = route.match(path);

    // One-shot redirect: if URL has a stale (pre-migration) parent account slug,
    // replace it with the current user's account slug and let the app behave as normal.
    // Only redirect when the URL slug differs from the user's account (avoids no-op
    // redirect and possible loop when a parent-account user visits their own URL).
    if (
      action.whoami?.feature_flags?.[
        'aws-brand-migration-axhe-3151-opening-redirect-enabled'
      ] &&
      parsed?.accountSlug &&
      MIGRATED_PARENT_ACCOUNT_SLUGS.includes(parsed.accountSlug) &&
      action.whoami?.account_name &&
      parsed.accountSlug !== action.whoami.account_name
    ) {
      const restOfPath = path.slice(`/${parsed.accountSlug}`.length);
      const newPathname = `/${action.whoami.account_name}${restOfPath}`;
      history.replace({ pathname: newPathname, search, hash });
      return;
    }

    // Now check if there is a mismatch between the brand in the url
    // and the selected brand in the store
    const brands = store.getState().auth.whoami.brands || initialState;

    if (!parsed) {
      /* eslint-disable-next-line no-console */
      console.error('Unable to parse route.  Check urlToStoreMiddleware.');
    }

    if (parsed?.brandSlug) {
      const newBrand = brands.find(
        brand => brand.slug === parsed.brandSlug && !brand.isAccount,
      );
      if (newBrand) {
        store.dispatch(setSelectedBrandAction(newBrand));
        // Set the selected location based on what's in the url
        if (parsed.locationId) {
          const newLocation = newBrand.locations.find(
            l => l.id === parsed.locationId,
          );
          if (newLocation) {
            store.dispatch(setSelectedLocationAction(newLocation));
          }
        }
      }
    } else {
      const account = brands.find(
        brand => brand.slug === parsed?.accountSlug && brand.isAccount,
      );
      if (account) {
        store.dispatch(setSelectedBrandAction(account));
      }
    }
  } else {
    next(action);
  }
};

export default urlToStoreMiddleware;
